import React, { Component } from 'react'

import { Wrapper, Link } from './styles'

class Footer extends Component {
  render() {
    const { type } = this.props

    return (
      <Wrapper type={type}>
        <Link href="https://kaarskoffie.nl" target="_blank">Kaarskoffie.nl</Link> |
        <Link href="https://bureaubright.nl" target="_blank">Realisatie: Bright</Link>
      </Wrapper>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js